'use client'

import Button from '../Button/Button';
import styles from './AcervoVirtual.module.css';
import { useRouter } from 'next/navigation';
import Link from 'next/link';

const AcervoVirtual = () => {
  const navigate = useRouter();
  
  return (
    <section>
      <div className={styles.dFlex}>
        <div className={styles.colLeft}>
          <div className={styles.plus}>
            <div className={styles.plusNumber} tabIndex={0}>+17 mil</div>
            <p tabIndex={0}>títulos disponíveis</p>
          </div>
        </div>
        <div className={styles.colRight}>
          <h2 className={styles.title} tab-index="0">
            <span>Seu acervo virtual</span> completo diversificado e sempre atualizado!
          </h2>
          <p tabIndex={0}>
            Desde 2005, a Biblioteca Virtual Pearson vem liderando em inovação para educação e desenvolvimento profissional. Com uma
            plataforma acessível e interativa, a Biblioteca Virtual oferece conteúdos abrangentes que enriquecem o conhecimento de estudantes
            e profissionais em uma experiência de leitura dinâmica e eficaz.
          </p>
          <Link href="/NossoAcervo" className="btnConheca" aria-label="Conheça nosso Acervo da Biblioteca Virtual">Conheça nosso Acervo</Link>
        </div>
      </div>
    </section>
  );
};

export default AcervoVirtual;